import React from 'react';
import Serial from './Serial';
import { serialCourseFetch } from '../../../actions/serial';

async function action({ store, params }) {
  if (params.id) await store.dispatch(serialCourseFetch(params.id, 0));
  const serialCourseData = store.getState().serial.serialInfo || {};
  const { title = '系列课程' } = serialCourseData;
  return {
    chunks: ['serialcourse'],
    title,
    component: <Serial />,
  }
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/serial/serial/index.js